module.exports = __webpack_public_path__ + "static/xmaspyjamas-226955fa93a47f0422fe8b46464a704b.jpeg";